import type {SlamPointCloud, SlamPointCloudCreate, SlamPointCloudUrls} from '@/domain/entities/SlamPointCloud';
import type {SlamPointCloudRepository} from '@/domain/interfaces/SlamPointCloudRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {SlamPointCloudDto} from './SlamPointCloudDto';
import {toDomain, toDto} from './SlamPointCloudMappers';

const PATH = 'slam-point-clouds/';

export class RestSlamPointCloudRepository implements SlamPointCloudRepository {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly multipartClient: HttpClient,
  ) {}
  create = async (entity: SlamPointCloudCreate) => {
    const dto = await this.httpClient.post<SlamPointCloudCreate, SlamPointCloudDto>(PATH, entity);
    return toDomain(dto);
  };
  getByInventoryPlotUuid = async (inventoryPlotUuid: string) => {
    const dtos = await this.httpClient.get<Array<SlamPointCloudDto>>(`${PATH}?inventoryPlotUuid=${inventoryPlotUuid}`);
    if (dtos.length !== 0) {
      return toDomain(dtos[0]);
    }
    return undefined;
  };
  get = async (uuid: string) => {
    const dto = await this.httpClient.get<SlamPointCloudDto>(`${PATH}${uuid}`);
    return dto ? toDomain(dto) : undefined;
  };
  delete = async (uuid: string) => {
    await this.httpClient.delete(`${PATH}${uuid}`);
  };
  patch = async (domain: SlamPointCloud): Promise<SlamPointCloud> => {
    const dto = await this.httpClient.patch<SlamPointCloudDto, SlamPointCloudDto>(
      `${PATH}${domain.uuid}`,
      toDto(domain),
    );
    return toDomain(dto);
  };
  getUrls = async (uuid: string) => {
    return await this.httpClient.get<SlamPointCloudUrls>(`${PATH}${uuid}/get-urls`);
  };
  upload = async (url: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    await this.multipartClient.post(url, formData);
  };
}
